module.exports = __webpack_public_path__ + "img/facebook.ed777b59.svg";